import { AosSeverity, isSeverityInkDark } from 'aos-services/src/services/common/types/AosSeverity'
import { colors } from 'aos-ui-universal/src/tokens'

interface TaskRef {
    severity: AosSeverity
}

export function taskItemIconColor(inTooltip: boolean, item: TaskRef) {
    return inTooltip || isSeverityInkDark(item.severity)
        ? colors.content.inverted
        : colors.content.default
}
